import UnfoldLess from '@mui/icons-material/UnfoldLess';
import UnfoldMore from '@mui/icons-material/UnfoldMore';
import { SxProps } from '@mui/system';
import { t } from 'i18next';
import { useCallback, useRef } from 'react';

import OutlinedIconButton from '~components/Buttons/OutlinedIconButton';
import { MenuHandler } from '~components/Menu/Menu';

interface OrdersDispatchFiltersBarProps {
  expandedState: string;
  isOrderFormDrawerMinimized?: boolean;
  onExpandedStateChange: (expandedState: string) => void;
  onNewOrderClick: () => void;
  sx?: SxProps;
}

interface ExpandedStatesMenuProps extends Pick<
  OrdersDispatchFiltersBarProps,
  'expandedState' | 'onExpandedStateChange' | 'sx'
> {}

export function ExpandedStatesMenu({
  expandedState,
  onExpandedStateChange,
  sx,
}: ExpandedStatesMenuProps) {
  const menuHandler = useRef<MenuHandler>(null);

  const handleMenuItemClick = useCallback(
    (expandeState: string) => {
      onExpandedStateChange(expandeState);
      menuHandler.current?.onClose?.();
    },
    [onExpandedStateChange],
  );

  return (
    <OutlinedIconButton
      aria-label={t(
        expandedState === 'open'
          ? 'dispatch.dispatch_v2.collapse_all'
          : 'dispatch.dispatch_v2.expand_all',
      )}
      onClick={() => {
        if (expandedState === 'open') {
          handleMenuItemClick('closed');
        } else {
          handleMenuItemClick('open');
        }
      }}
      size="small"
      sx={sx}
      data-ui="page-dispatch__search-bar__button"
    >
      {expandedState === 'open' ? (
        <UnfoldLess sx={{ fontSize: '18px' }} />
      ) : (
        <UnfoldMore sx={{ fontSize: '18px' }} />
      )}
    </OutlinedIconButton>
  );
}
